<script>
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

export default {
    props: {
        options: Object,
        autoOpen: Boolean,
    },
    mounted() {
        Fancybox.bind(this.$refs.container, "[data-fancybox]", {
            ...(this.options || {}),
        });

        if (this.autoOpen) {
            this.$refs.container.querySelector("[data-fancybox]").click();
        }
    },
    updated() {
        Fancybox.unbind(this.$refs.container);
        Fancybox.close();

        Fancybox.bind(this.$refs.container, "[data-fancybox]", {
            ...(this.options || {}),
        });
    },
    methods: {
        close() {
            Fancybox.close();
        },
    },
    unmounted() {
        Fancybox.destroy();
    },
};
</script>

<template>
    <div ref="container">
        <slot v-bind="{ close }"></slot>
    </div>
</template>

<style></style>
